@if (model$ | async; as model) {
  @if ((isRequestSubmitTask$ | async) === false) {
    <mat-card appearance="outlined" class="mb-4">
      <p class="fs-5">{{ 'DEMAND_REQUEST.DETAIL.ASSET.TEMPLATE.LABEL' | translate }}</p>
      <div class="d-flex flex-row ms-3 ps-1">
        <mat-icon color="primary">info</mat-icon>
        <p class="ps-2 mb-0">
          {{ 'DEMAND_REQUEST.DETAIL.ASSET.TEMPLATE.DESCRIPTION' | translate }}
        </p>
      </div>
      <mat-selection-list [multiple]="false" [hideSingleSelectionIndicator]="true">
        <a class="asset-link" target="_blank" href="assets\custom\usz\Sachkostengegenüberstellung alt vs. neu.xlsx">
          <mat-list-option
            ><mat-icon>download</mat-icon>
            <span>{{ 'DEMAND_REQUEST.DETAIL.ASSET.MATERIAL_COST_COMPARISON.LABEL' | translate }}</span>
          </mat-list-option></a
        >
        <div class="d-flex flex-row ms-3 mt-2 ps-1">
          <mat-icon color="primary">info</mat-icon>
          <p class="ps-2 mb-0">
            {{ 'DEMAND_REQUEST.DETAIL.ASSET.MATERIAL_COST_COMPARISON.NOTE' | translate }}
          </p>
        </div>
        <a class="asset-link" target="_blank" href="assets\custom\usz\Kostenträgerrechnung DB4_DRG Analyse1.pdf">
          <mat-list-option
            ><mat-icon>download</mat-icon>
            <span>{{ 'DEMAND_REQUEST.DETAIL.ASSET.COST_UNIT_ACCOUNT.LABEL' | translate }}</span>
          </mat-list-option>
        </a>
      </mat-selection-list>
    </mat-card>
  }
  <formly-form [form]="form" [fields]="fields" [options]="options" [model]="model"></formly-form>
}
